/* eslint-disable max-lines */
export default {
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  title: {
    home: 'Inicio',
    dashboard: 'Dashboard',
    kpi: 'KPI',
    errorRisks: 'Error al pasar los riesgos',
    operations: 'Operaciones',
    operationsB2C: 'Operaciones_B2C',
    operationsB2B: 'Operaciones_B2B',
    operationsListB2C: 'Listado B2C',
    operationsListB2B: 'Listado B2B',
    expiration: 'Vencimientos',
    popupstore: 'Pop Up Store',
    showroom: 'Showroom',
    garage: 'Garaje',
    addPartner: 'Alta de partner',
    garageCampaigns: 'Listado',
    error404: 'No encontrada',
    error500: 'Error',
    accessDenied: 'Acceso denegado',
    newRequest: 'Nueva solicitud',
    newRequestB2B: 'Nueva solicitud B2B',
    campaignDetail: 'Detalle de campaña',
    operationDetailB2C: 'Detalle de operación B2C',
    operationDetailB2B: 'Detalle de operación B2B',
    oidcCallback: 'Procesando...',
    newCampaign: 'Nueva Campaña',
    editCampaign: 'Edición de campaña',
    cloneCampaign: 'Clonar Campaña',
    importantInformation: 'Información importante',
    productInformation: 'Información de producto',
    technicalDetails: 'Detalles técnicos',
    advancedEditCampaign: 'Edición avanzada de campaña',
    campaigns: 'Campañas',
    cms: 'CMS',
    editMultipleCampaigns: 'Edición múltiple de campañas',
    sortCampaigns: 'Ordenar campañas',
    imagesBench: 'Banco Imágenes',
    automaticPublication: 'Publicación Automática',
    automaticPublicationDetails: 'Publicación Automática | Detalle Publicación',
    publishOffers: 'Publicación Automática | Publicar Ofertas'
  },
  menu: {
    dashboard: 'Dashboard',
    kpi: 'KPI',
    operations: 'Operaciones',
    lists: 'Listados',
    operationsListB2C: 'Listado B2C',
    operationsListB2B: 'Listado B2B',
    expiration: 'Vencimientos',
    popupstore: 'Pop Up Store',
    showroom: 'Showroom',
    garage: 'Garaje',
    addPartner: 'Partner',
    garageCampaigns: 'Campañas',
    cms: 'CMS',
    imagesBench: 'Banco Imágenes',
    automaticPublication: 'Publicación Automática'
  },
  header: {
    account: {
      profile: 'Perfil',
      settings: 'Ajustes',
      logout: 'Cerrar sesión'
    }
  },
  message: {
    error: {
      notFound1: 'Ups! ¿Estás perdido?',
      notFound2: 'La página que está buscando no existe.',
      page500Text1: 'Ups... ¡Algo salió mal!',
      page500Text2: 'Lo sentimos. Por favor, inténtalo de nuevo más tarde.',
      accessDeniedText: 'Acceso denegado',
      accessDeniedReturn: 'Regresar a la página principal',
      oidcLoginError: 'Ups... ¡Algo salió mal en el inicio de sesión!',
      fileTypeMismatch: 'Sólo soportamos imágenes {accept}.',
      fileSizeExceed: 'Seleccione una imagen inferior a {size}.',
      fieldRequired: 'El campo {field} es obligatorio.',
      operationNotInterested:
        'La solicitud de estado no interesado no se ha podido llevar a cabo, inténtelo de nuevo.',
      operationCancel:
        'La solicitud de cancelación no se ha podido llevar a cabo, inténtelo de nuevo.',
      operationResendEmail:
        'La solicitud de reenvio de email no ha podido llevarse a cabo, inténtelo de nuevo.',
      reserveNewCampaign: 'Reserve una cantidad menor o igual que el número de coches en stock',
      errorDateFromNewCampaign: 'La fecha Desde tiene que ser menor o igual a la fecha Hasta',
      errorDateToNewCampaign: 'La fecha Hasta tiene que ser mayor o igual que la fecha Desde',
      errorTermKmsMatrix: 'Debe seleccionar al menos una combinación de plazo y kilometraje',
      errorCampaignNotExist: 'La campaña solicitada no existe',
      updateCampaign:
        'La solicitud de actualización no se ha podido llevar a cabo, inténtelo de nuevo.',
      updateMultipleCampaigns:
        'No se ha podido actualizar ninguna de las campañas seleccionadas, inténtelo nuevamente.',
      publishOmega: 'Errores al publicar en Omega.',
      unsubscribeCampaign: 'Error al intentar dar de baja la campaña.',
      unpublishCampaign: 'Error al intentar despublicar la campaña.',
      errorEditCampaignField: 'El campo no puede ser modificado',
      createNewNode:
        'La creación del nuevo recurso no se ha podido llevar a cabo, inténtelo de nuevo.',
      deleteNode: 'No se ha borrado correctamente el nodo, inténtelo de nuevo.',
      updateNode: 'El nodo no se ha actualizado correctamente.',
      deleleNodeModal:
        'El nombre del nodo insertado no coincide con el nodo a eliminar, inténtelo de nuevo. ',
      saveHolderMobileKo: 'No se ha podido enviar el sms, inténtelo de nuevo',
      sendSMSKo: 'No se ha podido enviar el sms correctamente, inténtelo de nuevo',
      operationResendSignature:
        'La solicitud de reenvío a firma no ha podido llevarse a cabo, inténtelo de nuevo.',
      riskKo: 'Puede ponerse en contacto con nosotros para mas información.',
      saveMassiveImages: 'Error al actualizar imágenes masivas',
      saveMultipleImages:
        'Error al actualizar las imágenes en una o mas campañas de las seleccionadas',
      saveImages: 'Error al actualizar las imágenes de la campañas seleccionadas',
      getBrands: 'Error al obtener las marcas',
      getModels: 'Error al obtener los modelos',
      getVersions: 'Error al obtener las versiones',
      getVehicles: 'Error al obtener el tipo de vehículo',
      genericImagesBenchFilters: 'Error al obtener los datos necesarios para continuar',
      errorPartnertitle: 'Error Partner',
      errorPartnerMessage: 'Pongase en contacto con un comercial',
      listIdVehicles: 'Error al obtener el listado de id de vehículos'
    },
    warning: {
      updateMultipleCampaigns: 'Las siguientes campañas no se han actualizado con éxito',
      selectNode: 'Seleccione un nodo: partner, plantilla o patrón',
      createNode: 'Rellene los campos para crear un nuevo nodo',
      deleteNode: 'Seleccione un nodo: plantilla, patrón o elemento',
      minImages: 'Debe seleccionar un mínimo de {minImages} imágenes.',
      galleryUpdateCampaign:
        'No se han podido guardar los cambios, revise la sección de imágenes y vuelve a intentarlo.'
    },
    success: {
      operationNotInterested: 'Solicitud de estado no interesado con éxito.',
      operationCancel: 'Solicitud cancelada con éxito.',
      operationResendEmail: 'Solicitud de reenvío completada con éxito',
      operationCreatedSuccess: 'La solicitud se ha generado correctamente.',
      updateCampaign: 'La solicitud de actualización se ha completado con éxito.',
      updateMultipleCampaigns: 'Se han actualizado con éxito todas las campañas seleccionadas',
      publishOmega: 'La publicación en Omega se ha completado con éxito.',
      unsubscribeCampaign: 'La campaña se ha dado de baja correctamente.',
      unpublishCampaign: 'La campaña se ha despublicado correctamente.',
      createNewNode: 'Se ha creado correctamente el nodo.',
      deleteNode: 'Se ha borrado correctamente el nodo.',
      updateNode: 'El nodo se ha actualizado correctamente.',
      saveHolderMobileOk: 'El móvil se ha guardado correctamente',
      sendSMSOk: 'El sms ha sido enviado correctamente',
      operationResendSignature: 'Solicitud de reenvío a firma completada con éxito',
      saveImages: 'Imágenes subidas correctamente'
    },
    question: {
      toDo: '¿Qué desea hacer?'
    },
    generic: {
      checkAccess: 'Verificando acceso',
      loadingData: 'Cargando datos',
      poweredBy: 'Desarrollado por',
      operationId: 'Número operación: ',
      generatedOffer: 'Oferta generada: ',
      total: 'Total',
      edited: 'Editado',
      removeCampaignsToEdit: 'Puede eliminar de este listado aquellas campañas qué no desee editar',
      oneCampaignToEdit: 'Al menos una campaña debe existir para editar su información',
      textCreateOperationModal: 'Creando la operación, espere por favor...',
      textRiskModal: 'Pasando riesgos, espere por favor...',
      loadingTextModal: 'Procesando información, espere por favor...',
      getImages: 'Obteniendo imágenes',
      saveImages: 'Guardando imágenes'
    }
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnSaveChange: 'Guardar cambios',
      btnLoadAll: 'Cargar todas',
      btnLoadPriority: 'Cargar prioritarias',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnNewRequest: 'Nueva solicitud',
      btnCampaignDetail: 'Detalle de campaña',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnNotInterested: 'No interesado',
      btnResendMail: 'Reenviar mail',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnExport: 'Exportar',
      btnContinue: 'Continuar',
      btnLoading: 'Cargando...',
      btnContract: 'Contratar',
      btnMoreInfo: 'Más información',
      btnSend: 'Enviar',
      btnSavePartner: 'Guardar partner',
      btnChooseImage: 'Selecciona una imagen',
      btnRemoveImage: 'Remover imagen',
      btnSelectAll: 'Seleccionar todos',
      btnUnSelectAll: 'Deseleccionar todos',
      btnShowroom: 'Ver en Showroom',
      btnCancelOperation: 'Cancelar operación',
      btnReloadRegisters: 'Recargar registros',
      btnTesla: 'Ver operaciones en "Tesla" ',
      btnCreateCampaign: 'Crear Campaña',
      btnRetrieveOffer: 'Recuperar oferta',
      btnToday: 'Hoy',
      btnThreeMonths: '+3m',
      btnMoreOptions: 'Más opciones',
      btnAccessoriesSelectAll: 'Seleccionar todos',
      btnAccessoriesUnSelectAll: 'Borrar todos',
      btnAccessoriesShowSelected: 'Mostrar seleccionados',
      btnAccessoriesShowAll: 'Mostrar todos',
      btnCopy: 'Copiar',
      btnCopyAll: 'Copiar todo',
      btnPreviewCampaign: 'Previsualizar campaña',
      btnMoreFilters: 'Más filtros',
      btnAdvancedEdit: 'Edición avanzada',
      btnSetToManualStudy: 'Pasar a estudio manual',
      btnReservedQuotes: 'Limpiar oferta',
      btnSendSms: 'Enviar SMS',
      sortCampaigns: 'Ordenar campañas',
      sortCampaignText: 'Es necesario seleccionar un partner para activar este botón',
      btnResendSignature: 'Reenviar a firma',
      btnResetFilters: 'Eliminar filtros',
      btnApplyFilters: 'Aplicar filtros',
      btnGetImages: 'Obtener imágenes',
      btnEraseCache: 'Borrar Caché',
      btnSaveImages: 'Guardar imágenes',
      btnNewGeneration: 'Nueva Generación',
      btnShowDetail: 'Ver detalle',
      btnPublish: 'Publicar',
      btnYes: 'Si',
      btnNo: 'No'
    },
    badge: {
      campaignFactory: 'PEDIDO A FÁBRICA',
      inStockAvailable: 'En Stock',
      arrivalDateExpected: 'Fh. Prev. llegada'
    },
    label: {
      brand: 'Marca',
      searchInput: 'Búsqueda',
      searchInputPlaceHolder: 'Inserte texto de búsqueda',
      color: 'Color',
      checkRememberMe: 'Recuérdame',
      accordionProcess: 'Confirma tu identidad',
      checkConfirmTerms:
        'Confirmo haber comunicado al interesado las condiciones de la oferta y recogido el consentimiento de proporcionar los datos personales con el fin de realizar la oferta.',
      month: 'mes',
      months: 'meses',
      doors: 'puertas',
      accessories: 'Accesorios',
      limit: 'Plazo',
      kms: 'Kms',
      yearKmsText: 'Kms. anuales',
      extraKmsText: 'Kms. Extra',
      refundKmsText: 'Kms. Abono no recorrido',
      yearKmsUnit: 'kms/año',
      initialContribution: 'Aportación inicial',
      partner: 'Partner',
      type: 'Tipo:',
      optionIncluded: 'Opciones incluidas:',
      equipment: 'Equipamiento',
      servicesIncluded: 'Servicios incluidos:',
      settingsIncluded: 'Ajustes de kilometraje:',
      newRequestTitle: 'Rellena los datos requeridos',
      newRequestSubTitle1: 'Prepara la documentación del prospecto para que te resulte más rápido.',
      newRequestSubTitle2: '¡Comienza ya!',
      garageCampaignsTitle: 'Gestor campañas',
      sortCampaignsTitle: 'Ordenar campañas',
      sortCampaignInfo: '* Las campañas que están en color son las que salen ordenadas según estén',
      sortCampaignInfo2: '* Si mueves las campañas acuerdate de pulsar en el boton Guardar cambios',
      operationsListB2C: 'Listado de operaciones B2C',
      operationsListB2B: 'Listado de operaciones B2B',
      operationsExpiration: 'Vencimiento de operaciones',
      company: 'Empresas',
      checkOperation: 'Marca la casilla para pasar la operación a nombre de una empresa',
      operationDetailTitleB2C: 'Detalle de operación B2C',
      operationDetailTitleB2B: 'Detalle de operación B2B',
      reference: 'Referencia',
      copyDataContact: 'Marcar si los datos coinciden con los del contacto',
      operationId: 'ID Operación',
      agent: 'Agente',
      dischargeDate: 'Alta',
      updateDate: 'Actualizado',
      deliveryDate: 'Entrega',
      riskStatus: 'Estado de riesgo',
      operationStatus: 'Estado de operación',
      signatureStatus: 'Estado de firma',
      function: 'Función',
      identificationDocument: 'Documento de identidad',
      name: 'Nombre',
      email: 'E-mail',
      phone: 'Teléfono',
      mobile: 'Móvil',
      address: 'Dirección',
      postalCode: 'Código postal',
      city: 'Ciudad',
      province: 'Provincia',
      businessName: 'Razón social',
      cif: 'CIF',
      companyData: 'Datos de la empresa',
      companyName: 'Nombre (Razón Social)',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      titleLogin: 'Iniciar sesión',
      subTitleLogin: 'Introduce tu usuario',
      loginDescription:
        'Para acceder debes estar registrado como partner. Para cualquier duda, contacta con tu asesor comercial.',
      originCampaign: 'Origen',
      partnerName: 'Nombre Partner',
      partnerNameLOPD: 'Nombre Partner LOPD',
      partnerNameLOPDEmail: 'Email de contacto Partner',
      partnerAssociatedCommercial: 'Comercial asociado',
      partnerTheme: 'Theme',
      partnerLOPD: 'Texto Legal LOPD',
      partnerLOPDWeb: 'Texto Legal WEB SOLVENCIA',
      partnerLogos: 'Logos Partner',
      partnerLogosFooter: 'Logos Pie de página',
      partnerIdLleida: 'Id firma Lleida',
      partnerAppVersion: 'Versión aplicación',
      themeName: 'Nombre del Theme',
      themePrimaryColor: 'Color primario',
      themeSecondaryColor: 'Color secundario',
      iva: 'IVA',
      newCampaignTitle: 'Por favor, introduce un nuevo nombre para la campaña clonada',
      markdownTitleContents: 'Contenido',
      markdownTitlePreview: 'Vista previa',
      campaignName: 'Nombre Campaña',
      channel: 'Canal',
      id: 'Id',
      dateCampaignActive: 'Fechas Campaña Activa',
      groupCampaigns: 'Grupo de Campañas',
      contract: 'Contrato',
      services: 'Servicios',
      contractTextTermConditions: 'Texto Condiciones de Servicio',
      textSecure: 'Texto seguro',
      textSelfDamage: 'Texto daños propios',
      contractTextWarranty: 'Garantía',
      firstDebitDueDate: 'Fecha entrada vigor contrato',
      warrantyFeeDescription: 'A la firma del contrato:',
      warrantyFeeDescriptionTitle: 'Depósito en garantía',
      nonPaymentCompensation: 'Compensación por no pago',
      contractTextDebitReturnFee: 'Gastos devolución cuota',
      tableServicesPostSubtotal: 'Reparación daños propios',
      renter: 'Arrendatario',
      renterName: 'Nombre',
      renterLegalRepresentative: 'Representante Legal',
      renterAddress: 'Dirección',
      renterPostalCode: 'Código Postal',
      renterEmail: 'Email',
      renterCompanyName: 'Razón social',
      renterLegalRepresentativeDocumentId: 'DNI',
      renterAddressCity: 'Población',
      renterPhone: 'Teléfono',
      renterBillingEmail: 'Email de Facturación',
      renterDocumentId: 'CIF',
      renterAddressProvince: 'Provincia',
      renterCustomerCareEmail: 'Atención al Cliente',
      renterCustomerCarePhone: 'Teléfono de Atención al Cliente',
      renterSignature: 'Firma',
      manualSignatureInstructions: 'Instrucciones para la firma manual',
      contractTextDocumentsIncluded: 'Documentos Incluidos en el Contrato',
      signatureDig: 'Electrónica',
      signatureMan: 'Manual',
      contractTemplateName: 'Nombre plantilla Contrato',
      contractVersion: 'Versión',
      contractName: 'Nombre Contrato',
      contractId: 'ID Contrato',
      contractEmailSupport: 'Email de soporte',
      partnerLogoLeft: 'Logo izquierdo',
      partnerLogoRight: 'Logo derecho',
      tooltipTitleGallery: 'Abrir directorio de la nube',
      addCustomersAssociated: 'Añadir clientes',
      campaignCustomersAssociated: 'Clientes asociados a la campaña',
      customersList: 'Listado de clientes',
      dragCustomersHere: 'Arrastra clientes aquí',
      search: 'Buscar',
      risk: 'Riesgo',
      state: 'Estado',
      operation: 'Operación',
      contractLogoLeft: 'Logo Izquierdo',
      contractLogoRight: 'Logo Derecho',
      addNewContractTextDocument: 'Añadir documento',
      typeVehicle: 'Tipo de oferta',
      bodyStyleVehicle: 'Tipo de carrocería',
      kilometers: 'Kilometraje',
      typeFuel: 'Tipo de Combustible',
      typeModality: 'Modalidad',
      bodyStyle: 'Tipo de Cuerpo',
      rangePrice: 'Rango de precios',
      emissionsFilter: 'Filtro de emisiones',
      all: 'Todos',
      new: 'Nuevo',
      used: 'Usado',
      sale: 'Venta',
      km0: 'Km0',
      km: 'Km',
      registrationYear: 'Año de Matriculación',
      selected: 'Seleccionados',
      ctrlclick: 'CTRL + Clic para seleccionar elementos separados',
      summary: 'Resumen',
      summary_contact: 'Resumen-Contacto',
      concession: 'Concesión',
      selectCustomer: 'Indica los clientes asociados a la nueva campaña',
      reservationOfferNumber: 'Número de ofertas de reservas',
      selectPartner: 'Selección Partner',
      filter: 'Búsqueda',
      plateNumber: 'Matricula',
      vehicleVersion: 'Versión',
      ubication: 'Ubicación',
      publishedIn: 'Publicado en: ',
      settingsKms: 'Ajuste de kilometraje: ',
      card: 'Ficha',
      detail: 'Detalle',
      activecampaigns: 'Campañas activas',
      stockvehicles: 'Vehículos en stock',
      globalStatus: 'Estado de riesgo',
      order: 'Pedido',
      internalOrder: 'Estado pedido',
      offer: 'Oferta',
      offerId: 'ID de la Oferta',
      term: 'Plazo (meses)',
      campaign: 'Campaña',
      partnersList: 'Listado de partners',
      offerCamp: 'Oferta madre',
      availableStock: 'Stock disponible',
      campaignDates: 'Fechas de Campaña',
      reserveStock: '¿Reservar el stock disponible?',
      messageStockZero: 'Inserte 0 para campaña sin reserva',
      reserve: 'Reservar',
      reserveCars: 'coches',
      reserveCar: 'coche',
      from: 'Desde',
      to: 'Hasta',
      termKms: 'Plazo/Kilometraje',
      selectContractTemplate: 'Selecciona la plantilla del contrato',
      hasClients: '¿Tiene Concesiones/Clientes?',
      commercialSedan: 'Berlina comercial',
      gateSedan: 'Berlina con portón',
      frontisCab: 'Cabina frontis',
      platformCab: 'Cabina plataforma',
      cabrio: 'Cabrio',
      openBox: 'Caja abierta',
      truck: 'Camión',
      movingVan: 'Capitoné',
      cabChassis: 'Chasis cabina',
      doubleCabChassis: 'Chasis doble cabina',
      frontisChassis: 'Chasis frontis',
      combi: 'Combi',
      commercial: 'Comercial',
      coupe: 'Coupe',
      familiar: 'Familiar',
      passengerVanDerivatives: 'Furg?n deri. tur.',
      van: 'Furgón',
      glazedVan: 'Furgón acristalado',
      miniBus: 'Mini bus',
      miniCar: 'Minicoche',
      miniVan: 'Monovolumen',
      compactMinivan: 'Monovolumen compacto',
      pickup: 'Pickup',
      pickupDerivatives: 'Pickup derv. turismo',
      sedan: 'Sedán',
      targa: 'Targa',
      allTerrainCommercial: 'Todoterr. comercial',
      allTerrain: 'Todoterreno',
      caravanVehicle: 'Vehículo caravana',
      tipper: 'Volquete',
      included: 'Incluido',
      notIncluded: 'No incluido',
      notIncorporated: 'No incorporado',
      mark: 'Marca',
      modelName: 'Modelo',
      configuration: 'Configuración',
      engineType: 'Tipo de motor',
      bulletPoints: 'Apartados',
      bulletPoint: 'Apartado',
      multimediaFunctionality: 'Sistemas multimedia',
      specialFeatures: 'Servicios especiales',
      acceleration: 'Aceleración',
      colorName: 'Color',
      colorMap: 'Color mapa',
      driveSystem: 'Sistema de conducción',
      fuelCapacity: 'Capacidad de combustible',
      fuelEconomyCity: 'Ahorro de combustible en ciudad',
      fuelEconomyHighway: 'Ahorro de combustible en carretera',
      fuelEconomyCombined: 'Ahorro de combustible combinado',
      interiorColor: 'Color del interior',
      interiorColorName: 'Nombre del color del interior',
      transmissionType: 'Tipo de transmisión',
      genericKeywords: 'Claves genéricas',
      car: 'Coche',
      stockAvailable: 'Stock',
      publishDraft: 'Publicar en draft',
      campaignForPublish: 'Campaña a publicar',
      price: 'Precio',
      pricePrevious: 'Precio anterior',
      motorization: 'Motorización',
      finished: 'Acabado',
      legalNote: 'Nota legal',
      interior: 'Interior',
      version: 'Tipo de motor',
      numberOfDoors: 'No. de Puertas',
      maximumCompatibleNumberSeats: 'Max. Asientos Compatibles',
      modelYearRange: 'Rango Año Modelo',
      fuelType: 'Tipo de Combustible',
      storageVolume: 'Volumen de Almacenamiento',
      tireType: 'Tipo de Neumático',
      maximumHorsepower: 'Max. Caballo de Fuerza (cv)',
      maximumOutputPower: 'Nax. Potencia de Salida (kW)',
      engineDisplacement: 'Cilindrada',
      maximumSpeed: 'Velocidad Máxima',
      itemWeight: 'Peso del Producto',
      environmentalDescription: 'Etiqueta medioambiental',
      itemWidth: 'Longitud del Artículo',
      itemHeight: 'Altura del Artículo',
      includedFeatures: 'Características Incluidas',
      exitFromEdit: 'Hay cambios que no se han guardado, ¿quiere salir?',
      euEnergyLabelEfficiencyClass: ' Etiqueta de eficiencia energética',
      single: 'Individual',
      addBulletPoint: 'Añadir apartado',
      content: 'Contenido',
      preview: 'Vista previa',
      description: 'Descripción',
      driverLicense: 'Permiso de conducir',
      renovation: 'Renovación',
      renovationExplanation: ' (en caso de tener un coche con Ayvens que vayas a devolver)',
      firstRegistrationDate: 'Fecha de primer registro',
      salePrices: 'Precio de venta',
      pvp: 'P.V.P.',
      title: 'Título',
      deleteNode: '¿Está seguro de querer eliminar el nodo?',
      insertCurrentNodeName: 'Por favor, inserte el nombre del nodo que quiere eliminar:',
      selectMultiple: 'Selección múltiple',
      reportExpertise: 'Ver informe de peritación',
      campaignsToEdit: 'Campañas a editar',
      selectPartnerWarning: 'Es necesario seleccionar un partner para activar este botón',
      reserved: 'Reservado',
      reservedNotContract: 'No se puede contratar porque está reservado',
      descriptionCosmos: 'Descripción',
      reserveAllStockInformation:
        '*Al seleccionar esta opción, se reservarán todos los vehículos disponibles de la oferta de compra anticipada a esta campaña.',
      flow: 'Flujo',
      templateType: 'Tipo de plantilla',
      customerName: 'Nombre Cliente',
      imagesBench: 'Banco de Imágenes',
      automaticPublication: 'Listado de Publicaciones',
      publishOffers: 'Listado de Ofertas',
      publicationDetail: 'Detalle Publicación',
      loadingSendExcels: 'Procesando fichero',
      masivePublicationStatusCreated: 'Creada',
      masivePublicationStatusFail: 'Fallo (Lote completo)',
      masivePublicationStatusReady: 'Lista para procesar',
      masivePublicationStatusPublished: 'Publicada',
      masivePublicationOfferStatusCreated: 'Creada',
      masivePublicationOfferStatusReady: 'Lista',
      masivePublicationOfferStatusPublished: 'Publicada',
      masivePublicationOfferStatusPartiallyPublished: 'Publicado parcial',
      masivePublicationOfferStatusError: 'Error en la publicación',
      masivePublicationOfferStatusInvalid: 'Invalidada (No cumple requisitos)',
      masivePublicationOfferStatusInvalid1: 'Invalidada (La oferta no existe)',
      masivePublicationOfferStatusInvalid2: 'Invalidada (La oferta no es de tipo 17)',
      masivePublicationOfferStatusInvalid3: 'Invalidada (La oferta está caducada)',
      masivePublicationOfferStatusInvalid4: 'Invalidada (La oferta existe en familia de ofertas)',
      masivePublicationOfferStatusInvalid5: 'Invalidada (La campaign template no es válida)',
      masivePublicationOfferStatusInvalid6: 'Invalidada (No hay stock)',
      masiveDetailError:
        'Ha ocurrido un error al obtener el detalle de la publicación, inténtelo más tarde por favor.',
      masiveofferId: 'Nº Oferta',
      masiveReserveStock: '¿Reservar el stock disponible?*',
      masiveReserveAllStockInformation:
        '*Al seleccionar esta opción, se reservarán todos los vehículos disponibles de la oferta de compra anticipada a esta campaña.',
      selectAll: 'Seleccionar todo',
      zone: 'Zona',
      vehicle: 'Vehículo',
      idVehicle: 'ID Vehículo'
    },
    select: {
      noResult: 'No hay resultados para mostrar',
      noResultPartner: 'No hay partners para mostrar',
      labelNew: 'nuevo',
      active: 'Activas',
      noActive: 'De baja',
      all: 'Todos'
    },
    name: {
      checkConfirmTerms: 'Confirmar comunicación de condiciones',
      color: 'Color'
    },
    placeholder: {
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      businessName: 'Razón social',
      cif: 'CIF',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      name: 'Nombre',
      surname: 'Primer apellido',
      surname2: 'Segundo apellido',
      documentTypes: 'Tipo de documento',
      documentId: 'Número de documento (DNI, NIE)',
      selectPartner: 'Por favor seleccione un partner',
      selectPartnerNameOrId: 'Buscar por nombre o id del Partner',
      userName: 'Usuario',
      newCampaignName: 'Nuevo nombre de campaña Ej {campaignName} 15K',
      partnerLogoImg: 'Deja tu PNG aquí',
      partnerLogoImgDescription:
        'El logo debe tener un fondo transparente y una altura máxima de 40px',
      customerName: 'Nombre Cliente',
      addReservation: 'Añade reserva y pulsa Enter',
      selectContractTemplate: 'Selecciona la plantilla del contrato',
      select: 'Selecciona {field}',
      newKeyword: 'Inserte nueva clave',
      issueDate: 'Fecha de emisión',
      insuranceType: 'Tipo de seguro',
      operationOwner: 'Operación de',
      insuranceMonthFee: 'Prima total anual',
      marketPlaceOrderId: 'Referencia interna'
    },
    table: {
      filterPlaceholder: 'Introduzca el término de búsqueda',
      perPage: 'por página',
      noResults: 'No hay registros para mostrar',
      noResultsFiltered: 'No hay registros que coincidan con su solicitud',
      count: 'Mostrando del {from} al {to} de {count} registros',
      countFiltered: 'Mostrando del {from} al {to} {visibility} de {count} registros filtrados',
      countPossible: 'Mostrando del {from} al {to} {visibility} de {count} registros posibles',
      countRecords: 'Mostrando {count} registros',
      active: 'registros activos',
      noActive: 'registros de baja',
      countCards: 'Mostrando {count} registros de {total} posibles',
      loading: 'Cargando datos...',
      dblclickedDetailTitle: 'Doble click para ver el detalle',
      fields: {
        campaignName: 'Campaña',
        actions: 'Acciones',
        id: 'Id',
        updated: 'Actualizado',
        photo: 'Foto',
        partner: 'Partner',
        origin: 'Origen',
        group: 'Grupo',
        to: 'Hasta',
        invisibility: 'Invisibilidad',
        version: 'vX',
        reference: 'Referencia',
        signUp: 'Alta',
        state: 'Estado',
        riskStatus: 'Estado riesgo',
        documentation: 'Documentación',
        sign: 'Firma',
        identification: 'Identificación',
        email: 'Email',
        user: 'Usuario',
        concession: 'Concesión',
        document: 'DNI/NIE',
        updateDate: 'Fecha de Actualización',
        expirationDate: 'Fecha de Vencimiento',
        monthFee: 'Mensualidad',
        pvp: 'P.V.P',
        pvpPrevious: 'P.V.P Anterior',
        model: 'Modelo',
        accessories: 'Accesorios',
        limit: 'Plazo',
        yearKms: 'Kms. anuales',
        downPayment: 'Aportación inicial',
        order: 'Pedido',
        internalOrderStatus: 'Estado pedido',
        vehicle: 'Vehículo',
        process: 'Proceso',
        offerCamp: 'Oferta Madre',
        offerClient: 'Oferta Cliente',
        createDate: 'Fecha Alta',
        custodyDate: 'Fecha Custodia',
        availableDate: 'Fecha Puesta a Disposición',
        pickupDate: 'Fecha Entrega',
        equipment: 'Equipamiento',
        marketplacePublication: 'Marketplace',
        stockAvailable: 'Stock',
        accessoryId: 'Id',
        accessoryDescription: 'Descripción',
        accessoryIncludedFeatures: 'Servicios incluidos',
        accessoryMultimedia: 'Sistemas multimedia',
        accessorySpecial: 'Servicios especiales',
        plateNumber: 'Matrícula',
        campaignType: 'Tipo Campaña'
      },
      menuCampaign: {
        new: 'Clona a nueva campaña',
        duplicate: 'Duplicar y baja',
        unsubscribe: 'Baja',
        publish: 'Publicar en Marketplace',
        edit: 'Editar campaña',
        publishOmega: 'Publicar en Omega',
        unpublish: 'Despublicar'
      },
      automaticPublication: {
        name: 'Nombre',
        status: 'Estado',
        date: 'Fecha',
        user: 'Usuario'
      },
      publishOffers: {
        campaignName: 'Nombre campaña',
        stock: 'Stock',
        color: 'Color',
        prescriptor: 'Prescriptor',
        origin: 'Origen',
        description: 'Descripción',
        template: 'Tipo Plantilla',
        dateFrom: 'Fecha desde',
        dateTo: 'Fecha hasta',
        select: 'Seleccionar',
        actions: 'Acciones',
        status: 'Estado',
        offerId: 'Nº Oferta',
        reserveAllStock: 'Reservar',
        stockAvailable: 'Stock Disponible'
      }
    },
    modal: {
      confirmRequestTitle: 'Operación ejecutada con éxito',
      titleConfirmDelete: 'Eliminar registro',
      contentConfirmDelete: '¿Seguro que desea eliminar el registro "{record}"?',
      cloneAndNewCampaignTitle: 'Va a crear una campaña a partir de una antigua',
      cloneAndUnsubscribeCampaignTitle: 'Va a duplicar la oferta y dar de baja la original',
      unsubscribeCampaignTitle: 'Va a dar de BAJA la campaña',
      unpublishCampaignTitle: 'Va a despublicar la campaña',
      publishOmegaTitle: 'Va a publicar la oferta en Omega',
      campaignId: 'Id de la oferta',
      oldCampaignId: 'Id de la oferta antigua',
      newCampaignId: 'NUEVO Nº de oferta',
      toDateInvisibility: 'Fecha invisibilidad',
      btnOkNewRequest: 'Ir al Showroom',
      btnCancelNewRequest: 'Nueva solicitud',
      createNewThemeTitle: 'Crear un nuevo Theme',
      titleMarketplace: 'Publicar en Marketplace',
      moveCAmapignTitle: '¿Quieres salir sin guardar?',
      moveCampaignMessage:
        'Has cambiado el orden de las campañas pero no has guardado. ¿Quieres salir sin guardar los cambios?',
      operation_not_to_disclose:
        'Esta operación no se puede deshacer. Por favor, confirma que quieres ejecutar la acción',
      publishCampaignTitle: 'Publicación campaña',
      exitTitle: 'Salir de edición de campaña',
      modalityTitle: 'Elegir una modalidad',
      flowsModalTitle: 'Elige flujo de contratación',
      modalitySingle:
        'Pulsa para publicar la oferta como campaña individual. Si has seleccionado plazos inferiores para el mismo kilometraje se crearán ofertas múltiples para el contrato “Matriz”',
      modalityFamiliar:
        'Pulsa para publicar la campaña como una familia de plazos/kilometrajes. El cliente podrá seleccionar su opción de plazo y kilometraje.',
      createCampaign: 'Crear campaña',
      createCampaignError: 'Error al crear la campaña',
      retrieveCampaignError: 'Error al recuperar campaña',
      existingOperation: 'Operación existente',
      invalidOperation: 'Operación inválida',
      deleteNode: 'Eliminar nodo',
      unpublishFromMarketplce: 'Seleccione el marketplace del cuál desea despublicar',
      releaseVehicleStock: 'Stock disponible : ',
      releaseVehicle: 'Introduzca el número de vehículos que desea liberar',
      releaseVehicleNotAvailable: 'No hay vehículos disponibles',
      releaseVehicleTitle: 'Liberar Vehículo',
      errorOcurred: 'Ha ocurrido un error inesperado',
      reservedQuotesTitle: 'Aviso',
      reservedQuotesText:
        'La oferta ya ha sido usada en una publicación anterior. ¿Desea limpiar la familia de ofertas?',
      operationExist: 'Operación existente',
      templatesEmptyTitle: 'Error al cargar plantillas',
      templatesEmptyText:
        'No se puede crear la campaña debido a un problema en la carga de plantillas, inténtelo más tarde por favor. ',
      cancelPublicationModalTitle: 'Salir publicación masiva',
      cancelPublicationModalText: '¿Quieres cancelar la publicación?'
    },
    notify: {
      successDelete: 'El registro "{record}" fue eliminado con éxito',
      errorDelete: 'Ocurrió un error al intentar eliminar el registro "{record}"',
      successAddPartner: 'Nuevo Partner creado con éxito'
    },
    tab: {
      general: 'General',
      car: 'Coche',
      accessories: 'Accesorios',
      images: 'Imágenes',
      contract: 'Contrato',
      risk: 'Riesgos',
      clients: 'Clientes',
      filter: 'Filtro',
      extendedFilters: 'Filtros extendidos'
    }
  },
  legal: {
    showroom:
      'IVA INCLUIDO en los importes. La fotografía puede no coincidir con la versión / accesorios ofertados. Válida para Península y Baleares. Válida hasta fin de existencias de la campaña.'
  }
};
